export default __webpack_public_path__ + "static/media/joinus.4f04f3f1.jpg";